import React from 'react'

const StarTermsAndConditions = ({getListButton, termsAndConditions, privacyPolicy}) => {
  return (
    <>
    {getListButton('Terms & Conditions', () => window.open(termsAndConditions, '_blank'))}
    {getListButton('Privacy Policy', () => window.open(privacyPolicy, '_blank'))}
  </>
  )
}

export default StarTermsAndConditions;
